import * as pxp from '../lib/pxp'
export const showGiftOptions = () =>
  pxp.isTreatment('Trmt_p2p_gift_options_collapsed') ||
  pxp.isTreatment('Trmt_p2p_gift_options_expanded')

export const expandGiftOptions = () =>
  pxp.isTreatment('Trmt_p2p_gift_options_expanded')
